import AgoraRTC, { AgoraRTCProvider, useRTCClient } from "agora-rtc-react";
import VideoCall from "../components/Agora/VideoCall";

const generateUID = () => Math.floor(Math.random() * 100000) + 1000;

const JoinAppointment = ({
  appId,
  appointment,
  channelName,
  isJoin,
  setIsJoin,
  token,
  user,
  provider,
}) => {
  const agoraClient = useRTCClient(
    AgoraRTC.createClient({ codec: "vp8", mode: "rtc" })
  );

  const uid = 103;

  return (
    <AgoraRTCProvider client={agoraClient}>
      <VideoCall
        appId={appId}
        appointment={appointment}
        channelName={channelName}
        handleClose={() => {
          setIsJoin(false);
        }}
        isJoin={isJoin}
        token={token}
        uid={uid}
        user={user}
        provider={provider}
      />
    </AgoraRTCProvider>
  );
};

export default JoinAppointment;
